import React, { createContext, useContext, useState, ReactNode } from "react";

export type Language = "de" | "en";

type LanguageContextType = {
    language: Language;
    toggleLanguage: () => void;
};

const LanguageContext = createContext<LanguageContextType | undefined>(
    undefined
);

export const useLanguage = () => {
    const ctx = useContext(LanguageContext);
    if (!ctx) {
        throw new Error("useLanguage must be used within a LanguageProvider");
    }
    return ctx;
};

type LanguageProviderProps = {
    children: ReactNode;
};

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
    const [language, setLanguage] = useState<Language>(
        () => (localStorage.getItem("lang") as Language) || "de"
    );

    const toggleLanguage = () => {
        setLanguage((prev) => {
            const next = prev === "de" ? "en" : "de";
            localStorage.setItem("lang", next);
            return next;
        });
    };


    return (
        <LanguageContext.Provider value={{ language, toggleLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};
